(() => {
  const siteHeader = $(".site-header");
  const headerIcons = $(".site-header .grid .site-header__icons");
  const logo = $("a.site-header__logo-image");

  const desktopNav = document.createElement("div");
  desktopNav.classList.add("corporate-nav");
  desktopNav.innerHTML = `
  <span>Contact Us For Special Corporate Rate</span>
  <span><a href="mailto:corporate@prismplus.sg">corporate@prismplus.sg</a></span>
  `;
  headerIcons.append($(desktopNav));

  const mobileNav = document.createElement("div");
  mobileNav.classList.add("corporate-nav", "corporate-nav-mob");
  mobileNav.innerHTML = `
  <span>Contact Us For Special Corporate Rate</span>
  <span><a href="mailto:corporate@prismplus.sg">corporate@prismplus.sg</a></span>
  `;
  siteHeader.append($(mobileNav));

  logo.prop("href", "#/");
})();
